export const config = {
  title: 'Red Seal Fireplace, Chimney and HVAC',
  meta: {
    description:
      'Red Seal Fireplace, Chimney and HVAC offers expert chimney repairs, fireplace installations, and HVAC services across Metro Vancouver, Fraser Valley, Vancouver Island, and beyond.',
    keywords: [
      'Chimney Repair',
      'Fireplace Installation',
      'Chimney Cleaning',
      'HVAC Services',
      'Red Seal Fireplace',
      'Metro Vancouver',
      'Fraser Valley',
      'Vancouver Island',
    ],
    author: 'Red Seal Fireplace, Chimney and HVAC',
    canonicalUrl: 'https://redsealmasonryhvac.com/',
  },
  sections: {
    header: {
      businessName: 'Red Seal Fireplace, Chimney and HVAC',
    },
    sectionB: {
      heroTitle: "Red Seal Fireplace, Chimney and HVAC",
      heroSubtitle: "Delivering Excellence in Chimney and HVAC Services",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "6046793330",
      phoneLabel: "(604) 679-3330",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2201414520/photo/roofer-sprays-water-on-brick-chimney-worker-prepares-cement-application-wearing-white-hard.jpg?s=612x612&w=0&k=20&c=Oi17jh63Vlp1sb1i5mUHN3Nb_GeAy3xhxXXO_IvIsRs=",
      cardData: [
        {
          title: "Expert Chimney Repairs",
          description:
            "Our certified professionals provide top-notch chimney repair services, ensuring your home's safety and warmth.",
        },
        {
          title: "Comprehensive HVAC Solutions",
          description:
            "We offer reliable heating and air conditioning services to keep your home comfortable year-round.",
        },
        {
          title: "Professional Fireplace Installations",
          description:
            "Transform your living space with our expert wood and gas fireplace installation services.",
        },
      ],
      description:
        "With over 50 years of experience, Red Seal Fireplace, Chimney and HVAC is your trusted partner for all chimney, fireplace, and HVAC needs across Metro Vancouver, Fraser Valley, Vancouver Island, and beyond.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our wide range of professional services tailored to meet your chimney, fireplace, and HVAC needs.',
      cards: [
        {
          title: 'Chimney Repair',
          description:
            'Expert chimney repair services ensuring your fireplace operates safely and efficiently.',
          imageSrc: 'https://media.istockphoto.com/id/1127843210/photo/contractor-builder-with-blue-hardhat-on-the-roof-caulking-chimney.jpg?s=612x612&w=0&k=20&c=y3oGxqEEcoJO6vvaYy9NfVemTGFkYVQEIA6sPIx1afs=',
          imageAlt: 'Chimney Repair',
        },
        {
          title: 'Fireplace Installation',
          description:
            'Professional installation of wood and gas fireplaces to enhance your home’s ambiance.',
          imageSrc: 'https://media.istockphoto.com/id/183755088/photo/tile-worker-placing-stacked-stone-piece-for-a-fireplace-surround.jpg?s=612x612&w=0&k=20&c=bvKU5idLHcaajSeUNMkSNgbJ-ytB_iPOzf0qvTtLKbc=',
          imageAlt: 'Fireplace Installation',
        },
        {
          title: 'Chimney Cleaning',
          description:
            'Comprehensive chimney cleaning services to maintain safety and performance.',
          imageSrc: 'https://media.istockphoto.com/id/1251016185/photo/silhouette-of-a-chimney-sweeper-on-top-of-a-roof.jpg?s=612x612&w=0&k=20&c=u3J-BA_OtscMsllmhNuUCRrxlp2Sab0__fKP2D25g5w=',
          imageAlt: 'Chimney Cleaning',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'WETT Inspection',
        'HVAC Installation and Maintenance',
        'Chimney Sweeps',
        'Chimney Installation',
        'Pellet Stove Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://redsealmasonryhvac.com/wp-content/uploads/2024/03/ast.jpg',
        alt: 'Red Seal Fireplace, Chimney and HVAC Team',
      },
      aboutText: [
        'Red Seal Fireplace, Chimney and HVAC is a family-operated business with over 50 years of experience.',
        'We specialize in a wide array of services, from chimney sweeps and repairs to sophisticated fireplace installations and HVAC maintenance, enhancing your home’s comfort and safety.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Red Seal Fireplace, Chimney and HVAC Logo',
      businessName: 'Red Seal Fireplace, Chimney and HVAC',
      contact: {
        phone: '6046793330',
        phoneLabel: '(604) 679-3330',
        email: "redsealchimneyhvac@gmail.com",
        website: 'https://redsealmasonryhvac.com/',
        address: '177 5th St W #205, Vancouver, BC V7M 1J6, Canada',
      },
      socialMedia: {
        tiktok: 'https://www.tiktok.com/@redsealchimneyhvac',
      },
    },
    sectionF: {
      address: '177 5th St W #205, Vancouver, BC V7M 1J6, Canada',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2605.123456789012!2d-123.1234567!3d49.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5486712345678901%3A0xabcdef1234567890!2s177%205th%20St%20W%20%23205%2C%20Vancouver%2C%20BC%20V7M%201J6%2C%20Canada!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
